import { FormControlLabel, Grid, Switch as MUISwitch, SxProps, Typography } from '@mui/material';
import { Field, FieldProps } from 'formik';
import _ from 'lodash';
import * as React from 'react';

interface IProps {
  name: string;
  label: string;
  disabled?: boolean;
  sx?: SxProps;
  inline?: boolean;
}

const DEBUG = false;

const muiSwitch = (name: string) => {
  return (
    <Field name={name}>
      {(formikProps: FieldProps) => {
        DEBUG && console.debug('Switch', 'render field', { formikProps });
        const { form } = formikProps;
        return (
          <MUISwitch
            checked={_.get(form.values, name)}
            onChange={(e) => {
              DEBUG && console.debug('Switch', 'onChange!!', { e });
              form.setFieldValue(name, e.target.checked);
            }}
            color="primary"
            name={name}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
        );
      }}
    </Field>
  );
};

export const Switch = (props: IProps) => {
  const { label, name, sx, inline } = props;
  DEBUG && console.debug('Switch', 'render', props);

  if (inline) {
    return <FormControlLabel control={muiSwitch(name)} label={label} />;
  }

  return (
    <Grid container direction="row" justifyContent={sx ? undefined : 'space-between'} sx={sx}>
      <Grid>
        <Typography>{label}</Typography>
      </Grid>
      <Grid>{muiSwitch(name)}</Grid>
    </Grid>
  );
};
